import React from "react";
import { Chart } from "react-google-charts";
import { SupportedZoneTypes } from "../Constants";

const ParkingSpotPieChart = ({ data }) => {
  // Options for the pie chart
  const options = {
    //title: "Parking Spot Info",
    pieHole: 0.5,
    is3D: false,
    colors: ["#32CD32", "#4682B4", "#0000FF", "#FFA500", "#FF0000", SupportedZoneTypes.BUS.color, SupportedZoneTypes.TRANSIT.color,
      SupportedZoneTypes.PASSENGER.color, SupportedZoneTypes.EV.color, SupportedZoneTypes.SHUTTLE_STOP.color
    ],
    legend: {
      position: 'none'
     // position: 'top',  // Set legend position to top
     // alignment: 'start',  // Align the legend entries at the start
      // textStyle: {
      //   fontSize: 12,  // Adjust font size for better fit
      //   bold: true,  // Optional: making text bold
      //   maxWidth: '80%'  // Max width in percentage of the chart area
      // }
    },
  };

  return (
    <Chart
      chartType="PieChart"
      data={data}
      options={options}
      width={"100%"}
      height={"350px"}
    />
  );
};

export default ParkingSpotPieChart;
